var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.post
    ? _c(
        "div",
        [
          _vm.isExecuteTarget === true && _vm.isLoading === false
            ? _c("div", { staticClass: "block" }, [
                _c("div", [
                  _c("label", { staticClass: "mr-4" }, [
                    _vm._v(_vm._s(_vm.$t("term.timeElapsed"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "is-size-4" }, [
                    _vm._v(_vm._s(_vm._f("numFormat")(_vm.elapsedTime))),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.seconds")))]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", { staticClass: "mr-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("term.timeElapsedOf", {
                          target: _vm.$t("term.thisQuestion"),
                        })
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "is-size-1" }, [
                    _vm._v(_vm._s(_vm._f("numFormat")(_vm.elapsedTimeCurrent))),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.seconds")))]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("post-content", {
            attrs: { post: _vm.post, "is-disp-title": false },
          }),
          _vm._v(" "),
          _vm.isExecuteTarget === true
            ? _c("div", { staticClass: "block mt-6" }, [
                _c("h3", { staticClass: "title is-5" }, [
                  _vm._v(_vm._s(_vm.$t("term.answer"))),
                ]),
                _vm._v(" "),
                _vm.post.answerType === "text"
                  ? _c("div", { staticClass: "block" }, [
                      _c(
                        "div",
                        { staticClass: "block" },
                        [
                          _c(
                            "b-radio",
                            {
                              attrs: { "native-value": "text" },
                              model: {
                                value: _vm.textInputType,
                                callback: function ($$v) {
                                  _vm.textInputType = $$v
                                },
                                expression: "textInputType",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("form.textInput")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-radio",
                            {
                              attrs: { "native-value": "handwrite" },
                              model: {
                                value: _vm.textInputType,
                                callback: function ($$v) {
                                  _vm.textInputType = $$v
                                },
                                expression: "textInputType",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("form.handwriteInput")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-radio",
                            {
                              attrs: { "native-value": "file" },
                              model: {
                                value: _vm.textInputType,
                                callback: function ($$v) {
                                  _vm.textInputType = $$v
                                },
                                expression: "textInputType",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("form.SelectFile")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.textInputType === "handwrite"
                        ? _c(
                            "div",
                            [
                              _c("handwrite-input", {
                                attrs: { "canvas-height-default": 300 },
                                model: {
                                  value: _vm.answerImageData,
                                  callback: function ($$v) {
                                    _vm.answerImageData = $$v
                                  },
                                  expression: "answerImageData",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.textInputType === "file"
                        ? _c(
                            "div",
                            [
                              _c("FileInput", {
                                attrs: {
                                  "uploader-options": _vm.uploaderOptions,
                                  "is-draggable": true,
                                },
                                model: {
                                  value: _vm.files,
                                  callback: function ($$v) {
                                    _vm.files = $$v
                                  },
                                  expression: "files",
                                },
                              }),
                              _vm._v(" "),
                              _vm.thumbnails.length > 0
                                ? _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "columns is-multiline is-tablet mt-6",
                                    },
                                    _vm._l(
                                      _vm.thumbnails,
                                      function (thumbnail, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass:
                                              "column is-one-quarter relative",
                                          },
                                          [
                                            _c("button", {
                                              staticClass:
                                                "delete absolute top-4 right-4",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteFile(index)
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("img", {
                                              attrs: {
                                                src: thumbnail,
                                                alt: "Thumbnail",
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("b-input", {
                                attrs: { type: "textarea", name: "answerText" },
                                on: {
                                  blur: function ($event) {
                                    return _vm.validateAnswerText()
                                  },
                                },
                                model: {
                                  value: _vm.answerText,
                                  callback: function ($$v) {
                                    _vm.answerText = $$v
                                  },
                                  expression: "answerText",
                                },
                              }),
                            ],
                            1
                          ),
                    ])
                  : _vm.post.answerType === "select"
                  ? _c(
                      "ul",
                      { staticClass: "block" },
                      _vm._l(_vm.post.answersHtml, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "mt-2 columns is-mobile is-1",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "column is-0 has-text-weight-semibold",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "has-text-weight-semibold" },
                                  [_vm._v(_vm._s(_vm.answerLabels[index]))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "column is-1 has-text-weight-semibold",
                              },
                              [
                                _c("b-radio", {
                                  attrs: {
                                    name: "answerNo",
                                    "native-value": index,
                                  },
                                  model: {
                                    value: _vm.answerNo,
                                    callback: function ($$v) {
                                      _vm.answerNo = $$v
                                    },
                                    expression: "answerNo",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("html-content", {
                              staticClass: "column",
                              attrs: { body: item },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mt-5" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-info",
                      attrs: { disabled: _vm.isEnabledSendAnswer === false },
                      on: { click: _vm.sendAnswer },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.send")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm.isLoading === false &&
              _vm.isExecuteTarget != null &&
              _vm.isExecuteTarget === false &&
              (_vm.post.answerExplanation ||
                _vm.post.answerExpImages.length > 0)
            ? _c(
                "div",
                { staticClass: "block mt-6" },
                [
                  _c("h3", { staticClass: "title is-4" }, [
                    _vm._v(_vm._s(_vm.$t("term.explanation"))),
                  ]),
                  _vm._v(" "),
                  _vm.post.answerExplanation
                    ? _c("html-content", {
                        staticClass: "column",
                        attrs: { body: _vm.post.answerExplanationHtml },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("EbImages", {
                    attrs: { images: _vm.post.answerExpImages },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isExecuteTarget === false && _vm.isUserAuth
            ? _c("UserEditMasterStatus", {
                attrs: {
                  "post-service-id": _vm.serviceId,
                  "post-id": _vm.post.postId,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isExecuteTarget === false && _vm.isUserAuth
            ? _c("div", { staticClass: "mt-6" }, [
                _c("h3", { staticClass: "title is-4" }, [
                  _vm._v(_vm._s(_vm.$t("term.answers"))),
                ]),
                _vm._v(" "),
                _vm.userAnswers
                  ? _c(
                      "ul",
                      _vm._l(_vm.userAnswers, function (answer) {
                        return _c(
                          "li",
                          { staticClass: "mt-4 card px-2 py-5" },
                          [
                            _c("p", [
                              _c(
                                "time",
                                {
                                  attrs: {
                                    itemprop: "datepublished",
                                    datetime: _vm._f("dateFormat")(
                                      answer.finishedAt,
                                      ""
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateFormat")(answer.finishedAt)
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "mt-4",
                                attrs: {
                                  to: `/user/answers/${answer.userAnswerId}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("common.ShowDetail")) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _c("p", [_vm._v(_vm._s(_vm.$t("msg['Data is empty']")))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isExecuteTarget === false && _vm.post.category
            ? _c(
                "nav",
                {
                  staticClass: "breadcrumb",
                  attrs: { "aria-label": "breadcrumbs" },
                },
                [
                  _c(
                    "ul",
                    [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: `/posts/${_vm.serviceId}/` } },
                            [_vm._v(_vm._s(_vm.$t("common.posts")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.post.category.parents, function (parent) {
                        return _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/posts/${_vm.serviceId}/categories/${parent.slug}`,
                                },
                              },
                              [_vm._v(_vm._s(parent.label))]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: `/posts/${_vm.serviceId}/categories/${_vm.post.category.slug}`,
                              },
                            },
                            [_vm._v(_vm._s(_vm.post.category.label))]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          "tags" in _vm.post && _vm.post.tags
            ? _c(
                "ul",
                _vm._l(_vm.post.tags, function (tag) {
                  return _c(
                    "li",
                    { staticClass: "is-inline-block mr-2" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "tag",
                          attrs: {
                            to: `/posts/${_vm.serviceId}/tags/${tag.label}`,
                          },
                        },
                        [_vm._v(_vm._s(tag.label))]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }